import { chakra, Tag } from "@chakra-ui/react";
import { PatientExtendedData } from "../../../../../public/admin/scripts/messages/patient";

interface Props {
  patient: PatientExtendedData;
}

export default function MissingTaskBanner({ patient }: Props) {
  if (!patient?.currCertPeriodTaskStatus) {
    return null;
  }

  const showBanner =
    patient.currCertPeriodTaskStatus === "MISSING_SOC" ||
    patient.currCertPeriodTaskStatus === "MISSING_RA";

  if (!showBanner) {
    return null;
  }

  const bannerText =
    patient.currCertPeriodTaskStatus === "MISSING_SOC"
      ? "❗ Missing SOC ❗"
      : "❗ Overdue Reassessment ❗";

  return (
    <BaseTag bg="yellow.400" color="blackAlpha.700" colorScheme="yellow">
      {bannerText}
    </BaseTag>
  );
}

const BaseTag = chakra(Tag, {
  baseStyle: {
    padding: 3,
    lineHeight: 1.5,
  },
});
